<template>
<div>
  <span class="grant" v-if="status === 'grant'">Aprovado</span>
  <span class="deny" v-if="status === 'deny'">Rejeitado</span>
  <span class="processing" v-if="status === 'processing'">Em análise</span>
  <span class="pendency" v-if="status === 'pendency'">Sob correção</span>
</div>
</template>

<script>
export default {
  props: ['status']
}
</script>

<style scoped>
.grant {
  color: green
}
.deny {
  color: red
}
.processing {
  color: blue
}
.pendency {
  color: #bf9600
}
</style>



// WEBPACK FOOTER //
// RequestStatus.vue?4e3a1cfd